/**
 * *******************************************
 * *******************************************
 * ******** CustomInputType Directive ********
 * *******************************************
 * *******************************************
 * 
 * PARAMETERS
 *      psiCustomInputType (CustomInputType)  - Name of Type you want to use CustomInput as. We have CustomInputType ENUM as well. 
 *          AMOUNT
 *          PHONE
 *          NUMBER
 * 
 *      maximumFractionDigits (Number)        - Maximum fraction digits for AMOUNT and NUMBER CustomInput. By default its 0.
 * 
 *      allowBlank (Boolean)                  - If false, onBlur it will set value as 0. By default its false
 *      
 * 
 * This directive will show actualValue (Plain Number always) on Focus of the CustomInput. And when we FocusOut of the CustomInput, it will show the formatted value based on the type of CustomInput.
 * 
 * ```
 * Nimitt Shah
 * ```
 */

import { CurrencyPipe } from '@angular/common';
import { Directive, ElementRef, Input } from '@angular/core';
import { NgModel } from '@angular/forms';
import { CustomInputType } from '../_common/_enum/module.enum';
import { FormatInputTypePipe } from '../_pipes/format-input-type.pipe';

@Directive({
  selector: '[psiCustomInputType]',
  host: { '(blur)': 'convertValue($event.target.value)' , '(focus)': 'showOriginal($event)', '(input)': 'onInput($event)'}
})
export class CustomInputTypeDirective{
  @Input('psiCustomInputType') psiCustomInputType: string;
  @Input('maximumFractionDigits') maximumFractionDigits: number = 0;
  @Input('allowBlank') allowBlank: boolean = false;

  constructor(private ref: ElementRef, private currencyPipe: CurrencyPipe, private formatInputTypePipe: FormatInputTypePipe, public ngModel: NgModel) { }
  
  public actualValue: string;
  public onChange: any = (_) => { /*Empty*/ }
  public onTouched: any = () => { /*Empty*/ }


  onInput(_event){
    _event.target.value = _event.target.value.replace(/[^0-9.-]+/g, "");
    this.ref.nativeElement.value = _event.target.value;
    if (this.psiCustomInputType == CustomInputType.PHONE) {
      this.ref.nativeElement.actualValue = Number(_event.target.value.replace(/[^0-9]+/g, ""));
    } else {
      this.ref.nativeElement.actualValue = Number(_event.target.value.replace(/[^0-9.-]+/g, ""));
    }
  }

  /** Show Original Method is called on Focus event of CustomInput. eg., 1234567890 */
  showOriginal(_event) { 
    if (_event.target.value.replace(/[^0-9.-]+/g, "")) {      
      if (this.psiCustomInputType == CustomInputType.PHONE) {
        _event.target.value = Number(_event.target.value.replace(/[^0-9]+/g, ""));
      } else {
        _event.target.value = Number(_event.target.value.replace(/[^0-9.-]+/g, ""));
      }
      this.ref.nativeElement.value = _event.target.value;
      this.ref.nativeElement.actualValue = Number(_event.target.value.replace(/[^0-9.-]+/g, ""));
    }
    _event.target.select();
  }

    /***
     * If psiCustomInputType is Amount then convert inputted value into USD. eg., $123,456
     * If psiCustomInputType is Number then convert inputted value into US Number. eg., 123,456
     */
  convertValue(_value: any) {
    //let _numberFormatOption = {};
    let _convertedValue;
    _convertedValue = this.formatInputTypePipe.transform(_value, {psiCustomInputType:this.psiCustomInputType, allowBlank: this.allowBlank, maximumFractionDigits:this.maximumFractionDigits})

    this.ref.nativeElement.value = _convertedValue;
    
    if (this.psiCustomInputType == CustomInputType.PHONE) {
      this.ref.nativeElement.actualValue = Number(_convertedValue.replace(/[^0-9]+/g, ""));
    } else {
      this.ref.nativeElement.actualValue = Number(_convertedValue.replace(/[^0-9.-]+/g, ""));
    }
    
    this.ngModel.control.setValue(_convertedValue); //updates the value for the model
  }

  ConvertExposure(_value, _inputType) {
    if (_inputType == CustomInputType.NUMBER) {
      //_value = new Intl.NumberFormat('en-US', {maximumFractionDigits: this.maximumFractionDigits}).format(_value);
      var cleaned = ('' + _value).replace(/\D/g, '');
      var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
      if (match) {
        var intlCode = (match[1] ? '+1 ' : '');
        return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
      }
    }else if (_inputType == CustomInputType.NUMBER) {
      _value = new Intl.NumberFormat('en-US', {maximumFractionDigits: this.maximumFractionDigits}).format(_value);
    } else {
      if(this.maximumFractionDigits > 0){
        _value = this.currencyPipe.transform(_value, '$', 'symbol', '1.'+this.maximumFractionDigits+"-"+this.maximumFractionDigits);
      } else {
        _value = this.currencyPipe.transform(_value, '$', 'symbol', '1.0-0');
      }
    }
  }
}
